import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Creditor/Main";
import Form from "./Creditor/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataCreditor } from "../../../model/InitialData/InitialDataCreditor";

const Creditor = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataAPtype, setDataAPtype] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataCreditor());
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_AP ทั้งหมด
      const masterList = await getDataWithComp("View_Set_AP", "Order By AP_Id");
      const dataAPtype = await getData("Tb_Set_APType", "1=1");
      if (masterList && masterList.length > 0) {
        masterList.sort((a, b) => a.AP_Id - b.AP_Id);
        setDataMasterList(masterList);
      }
      if (dataAPtype && dataAPtype.length > 0) {
        setDataAPtype(dataAPtype);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");

    setFormData({
      ap_id: item.AP_Id,
      comp_id: window.localStorage.getItem("company"),
      ap_code: item.AP_Code,
      ap_name: item.AP_Name,
      ap_type: item.APType_Name,
      ap_shortname: item.AP_ShortName,
      ap_taxno: item.AP_TaxNo,
      ap_add1: item.AP_Add1,
      ap_add2: item.AP_Add2,
      ap_add3: item.AP_Add3,
      ap_province: item.AP_Province,
      ap_zipcode: item.AP_Zipcode,
      ap_contact: item.AP_Contact,
      ap_contact2: item.AP_Contact2,
      ap_tel: item.AP_Tel,
      ap_tel2: item.AP_Tel2,
      ap_group: item.AP_Group,
      ap_refsalecode: item.AP_RefSaleCode,
      ap_area: item.AP_Area,
      ap_status: item.AP_Status,
      ap_credit: item.AP_Credit,
      ap_vat: item.AP_Vat,
      ap_discount: item.AP_Discount,
      ap_branch: item.AP_Branch,
      ap_bt_name: item.AP_BT_Name,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#EF6C00",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div
          className={`main-panel ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลเจ้าหนี้"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลเจ้าหนี้"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataAPtype={dataAPtype}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Creditor;
